/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteTemplateConstraintCapacityDtoBase
 * auto generated base class for the model RouteTemplateConstraintCapacityDtoModel.
 */
export const RouteTemplateConstraintCapacityDtoModelBase = ModelBase
  .named('RouteTemplateConstraintCapacityDto')
  .props({
    __typename: types.optional(types.literal("RouteTemplateConstraintCapacityDto"), "RouteTemplateConstraintCapacityDto"),
    id: types.identifier,
    name: types.union(types.undefined, types.string),
    value: types.union(types.undefined, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteTemplateConstraintCapacityDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get name() { return this.__attr(`name`) }
  get value() { return this.__attr(`value`) }
}
export function selectFromRouteTemplateConstraintCapacityDto() {
  return new RouteTemplateConstraintCapacityDtoModelSelector()
}

export const routeTemplateConstraintCapacityDtoModelPrimitives = selectFromRouteTemplateConstraintCapacityDto().name.value
